import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Session } from '../Session/session.model';
import { SessionService } from '../Session/session.service';
import { Router } from '@angular/router';
import { ServerService } from '../Services/server.service';

@Injectable({
  providedIn: 'root'
})
export class ServiciologinService {
  
  private sessi : Session;
  private _userIsAuthenticate =false;
  private ip:string="";
  constructor(private server:ServerService,private http : HttpClient, private sessionService : SessionService, private route:Router) {
      this.ip=this.server.getIPServer();
   }
  login(){
    this._userIsAuthenticate=false;
  }
 
  logout(){
    this.sessionService.clearStoreAuthData();
    this.sessionService.sessionEnd();
    this._userIsAuthenticate=false;
    this.route.navigateByUrl('/Login');
  }
  get userIsAuthenticated(){
    return this._userIsAuthenticate;
  }

  oncheck(){
    this.sessionService.getStoreAuthData();
  }
  setMiembroData(){
    let mid=+this.sessionService.getMiembroID();
    let muid=+this.sessionService.getMunicipio();
    let cid=+this.sessionService.getCentro();
    console.log('Datos Iniciales',mid,cid,muid); 
    this.sessionService.setVariable('miembroID',mid)
    this.sessionService.setVariable('MunicipioID',muid);
    this.sessionService.setVariable('CentroID',cid);
  }
  async onVerify(): Promise<boolean> {
    if (this._userIsAuthenticate) {
      return true;
    }

    try {
      const result: any = await this.sessionService.getDataST();
      const storedData = result ? result.value : null;

      if (!storedData || storedData === 'NA') {
        this.clearInvalidSession();
        return false;
      }

      const data = JSON.parse(storedData);

      if (!this.isValidSessionData(data)) {
        this.clearInvalidSession();
        return false;
      }

      this.sessionService.setDataAuth(data);
      this._userIsAuthenticate = true;
      this.setMiembroData();
      return true;
    } catch (error) {
      console.error('Error verificando sesion', error);
      this.clearInvalidSession();
      return false;
    }
  }

  async onLogin(user:string , pw:string): Promise<boolean> {
    try {
      const dato: any = await this.http.post(this.ip+'/Siget/Angular/session.php', {"json":{"user":user,"pw":pw}}).toPromise();
      let data= (dato);
      console.log(data);
      this.sessionService.sessionStart(data) ;
      if(this.sessionService.getFlag()){
        this.sessionService.storeAuthData();
        this._userIsAuthenticate=true;
        this.route.navigateByUrl('/SIGET');
        return true;
      }

      this.clearInvalidSession();
      return false;
    } catch (error) {
      console.error('Error iniciando sesion', error);
      this.clearInvalidSession();
      return false;
    }
  }

  private isValidSessionData(data: any): boolean {
    return !!data
      && Number(data.flag) === 1
      && Number(data.id) > 0
      && !!data.token
      && data.token !== 'NA';
  }

  private clearInvalidSession() {
    this.sessionService.sessionEnd();
    this.sessionService.clearStoreAuthData();
    this._userIsAuthenticate = false;
  }
}
